import React from "react";
import {Modal,Box,CircularProgress} from '@mui/material';
import { useSelector } from "react-redux";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // bgcolor: 'background.paper',
    // boxShadow: 24,
    outline: "none",
    borderRadius : "4px",
  };

const LogoutSpinner = () => {

    const {
        logoutStatus
    } = useSelector((state) => state.logoutReducer);

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={logoutStatus}
        >
                <Box sx={style}>
                    <CircularProgress style={{width:'80px',height:'80px'}} />
                </Box>
        </Modal> 

    );
};

export default LogoutSpinner;